<ngx-spinner bdColor="rgba(51,51,51,0.60)">

  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
<router-outlet></router-outlet>
